/* Opens Shopify's existing preferences UI only after a visitor clicks. */
(function () {
  "use strict";
  if (window.__dtfCookiePreferencesInstalled) return;
  window.__dtfCookiePreferencesInstalled = true;
  const bound = new WeakSet();
  const WAIT_MS = 5000;
  const POLL_MS = 100;

  function bind(scope) {
    const roots = Array.from(scope.querySelectorAll("[data-dtf-cookie-preferences]"));
    if (scope.matches?.("[data-dtf-cookie-preferences]")) roots.unshift(scope);
    for (const root of roots) {
      if (bound.has(root)) continue;
      const button = root.querySelector("[data-cookie-preferences-open]");
      const status = root.querySelector("[data-cookie-preferences-status]");
      const message = root.querySelector("[data-cookie-preferences-message]");
      const policy = root.querySelector("[data-cookie-preferences-policy]");
      if (!button || !status || !message || !policy) continue;
      bound.add(root);
      let busy = false;
      let attempt = 0;

      button.addEventListener("click", function () {
        if (busy) return;
        busy = true;
        const current = ++attempt;
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("aria-busy", "true");
        status.hidden = false;
        policy.hidden = true;
        message.textContent = "Opening cookie preferences…";
        let finished = false;
        let poll = null;
        let deadline = null;

        function finish(error) {
          if (finished || current !== attempt) return;
          finished = true;
          if (poll !== null) clearTimeout(poll);
          if (deadline !== null) clearTimeout(deadline);
          busy = false;
          button.removeAttribute("aria-disabled");
          button.removeAttribute("aria-busy");
          if (error) {
            status.hidden = false;
            policy.hidden = false;
            message.textContent =
              "Cookie preferences couldn't open. Please try again or reload this page. ";
          } else {
            status.hidden = true;
            message.textContent = "";
          }
        }

        function openWhenReady() {
          if (finished) return;
          if (!root.isConnected) {
            finish(true);
            return;
          }
          const banner = window.privacyBanner;
          if (!banner || typeof banner.showPreferences !== "function") {
            poll = setTimeout(openWhenReady, POLL_MS);
            return;
          }
          try {
            Promise.resolve(banner.showPreferences()).then(
              function () {
                finish(false);
              },
              function () {
                finish(true);
              },
            );
          } catch (_) {
            finish(true);
          }
        }

        deadline = setTimeout(function () {
          finish(true);
        }, WAIT_MS);
        openWhenReady();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        bind(document);
      },
      { once: true },
    );
  } else {
    bind(document);
  }
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && typeof event.target.querySelectorAll === "function") bind(event.target);
  });
})();
